<template>
  <div class="container setting">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/senior/list' }">学长管理</el-breadcrumb-item>
        <el-breadcrumb-item>学长详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="right">
          <el-button plain
                     @click="handleClose">返回</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main card">
      <h3 class="title">学长详情</h3>
      <div class="baseinfo content">
        <div class="form-header">
          <div class="form-header-inner">基础信息</div>
        </div>
        <el-form ref="userForm"
                 label-width="100px"
                 class="userForm">
          <el-form-item label="头像：">
            <img class="avatar"
                 :src="senior.avatar" />
          </el-form-item>
          <el-form-item label="昵称：">
            <el-input v-model="senior.nickname"
                      clearable
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="senior.realname"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="性别：">
            <el-select v-model="senior.gender"
                       placeholder="请选择性别">
              <el-option label="学长"
                         :value="1"></el-option>
              <el-option label="学姐"
                         :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="senior.mobile"
                      clearable> </el-input>
          </el-form-item>
          <el-form-item label="课时费："
                        prop="fee_amount">
            <el-input v-model="senior.fee_amount"
                      clearable
                      style="width: 200px">
              <template slot="append">元/小时</template></el-input>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input type="textarea"
                      v-model="senior.description"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="内部备注：">
            <el-input type="textarea"
                      v-model="senior.contract_remark"
                      clearable>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="education content">
        <div class="form-header">
          <div class="form-header-inner">学历信息</div>
        </div>
        <div class="education-wrap">
          <el-form class="form-wrap"
                   label-width="100px">
            <el-form-item label="考研年份：">
              <el-select v-model="senior.recruit_year"
                         placeholder="请选择">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取院校：">
              <el-select v-model="senior.recruit_college_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取专业：">
              <!--  <span>{{ senior.recruit_major_name }}</span> -->
              <el-select v-model="senior.recruit_major_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取学院：">
              <el-select v-model="senior.recruit_academy_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="academyChange">
                <el-option v-for="(item, index) in academyList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取方向：">
              <el-select v-model="senior.recruit_direction_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 600px"
                         @change="directionChange">
                <el-option v-for="(item, index) in directionList"
                           :key="index"
                           :label="item.direction"
                           :value="item.direction_code">
                  <span>{{ `${item.direction}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试科目：">
              <!--  <span>{{ senior.test_subject_names }}</span> -->
              <el-select v-model="senior.test_subject_codes"
                         multiple
                         placeholder="请选择"
                         style="width: 600px">
                <el-option v-for="(item, index) in subjectsList"
                           :key="index"
                           :label="item.subject_name"
                           :value="item.subject_code">
                  <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="初试总分：">
              <el-input v-model="senior.initial_test_score"
                        clearable
                        maxlength="4"
                        style="width: 100px"></el-input>
            </el-form-item>
            <el-form-item label="科目分数：">
              <el-input v-model="senior.test_subject_scores"
                        clearable
                        style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="录取类型：">
              <!--  <span>{{ renderRecruitType(senior.recruit_type) }}</span> -->
              <el-select v-model="senior.recruit_type"
                         placeholder="请选择录取类型">
                <el-option label="第一志愿上岸"
                           :value="1"></el-option>
                <el-option label="调剂上岸"
                           :value="2"></el-option>
                <el-option label="推免"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取证明：">
              <el-upload class="cover-uploader"
                         :action="imgUploadUrl"
                         :limit="1"
                         :class="senior.recruit_certify_img ? 'hide_box' : ''"
                         list-type="picture-card"
                         :headers="uploadHeaders"
                         :file-list="recruitList"
                         :on-success="handleRecruitSuccess"
                         :on-remove="handleRecruitRemove">
                <i class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <!-- <el-image style="width: 120px; height: 120px"
                        :src="senior.recruit_certify_img"
                        :preview-src-list="[senior.recruit_certify_img]">
              </el-image> -->
            </el-form-item>
            <!--   -->
            <el-form-item label="视频简介：">
              <el-upload :limit='1'
                         :action="imgUploadUrl"
                         accept="video/*"
                         :on-remove="handleRemove"
                         :on-success="handleSuccess"
                         :file-list="fileList">
                <el-button slot="trigger"
                           size="small"
                           type="primary">选取视频文件</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="education content">
        <div class="form-header">
          <div class="form-header-inner">服务信息</div>
        </div>
        <div class="education-wrap">
          <el-form class="form-wrap"
                   label-width="100px">
            <el-form-item label="服务提供：">
              <p v-for="(item, $i) in senior.provide_services
                  ? senior.provide_services.split(',')
                  : []"
                 :key="$i">
                {{ renderProvideService(item) }}
              </p>
            </el-form-item>
            <el-form-item label="优势描述：">
              <!-- <span>{{ senior.additional || "-" }}</span> -->
              <el-input type="textarea"
                        clearable
                        v-model="senior.additional"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { seniorOne, seniorUpdateStatus, seniorUpdate } from '@/api/senior'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
export default {
  components: {},
  data() {
    return {
      directionList: [],
      collegeCode: '',
      majorCode: '',
      fileList: [],
      recruitList: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      senior: {},
      majorList: [],
      subjectsList: [],
      academyList: [],
      rules: {
        fee_amount: [
          { required: true, message: '请输入划线价', trigger: 'blur' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
      },
    }
  },
  created() {
    this.fetchSeniorInfo()
    this.$store.dispatch('getAllColleges')
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    handleRecruitSuccess(res, fileList) {
      console.log('fileList', fileList)
      this.recruitList = fileList
      if (res.code == 0 && res.data) {
        this.senior.recruit_certify_img = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleRecruitRemove(file, fileList) {
      this.recruitList = fileList
      this.senior.recruit_certify_img = ''
    },
    handleSuccess(response, file, fileList) {
      // console.log("xx",fileList)
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },

    // 学长基本信息
    fetchSeniorInfo() {
      seniorOne({ uid: this.$route.params.seniorId }).then((res) => {
        if (res) {
          console.log('res', res)
          if (res.recruit_certify_img == '') {
            this.recruitList = []
          } else {
            this.recruitList = [
              {
                url: res.recruit_certify_img,
              },
            ]
          }
          if (res.intro_video_url) {
            this.fileList = res.intro_video_url.split(',').map((item) => ({
              name: item,
              url: item,
            }))
          }
          res.status = res.status == 1 ? true : false
          this.senior = res
          this.senior.test_subject_codes =
            this.senior.test_subject_codes.split(',')
          this.getAcademy(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.getMajor(this.senior.recruit_college_code)
          this.getSubjectsByMajorCode(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.majorDirect(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
        }
      })
    },
    // 状态更新
    updateStatus() {
      seniorUpdateStatus({
        id: this.senior.id,
        status: this.senior.status ? 1 : 0,
      })
        .then((res) => {
          this.$message.success(`学长学姐状态更新成功`)
          // 刷新数据
          this.fetchSeniorInfo()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 返回
    handleClose() {
      this.$router.go(-1)
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    renderProvideService(type) {
      const services = {
        1: '资料-整理备考资料',
        2: '经验-分享上岸经验',
        3: '小讲-录制语音课程',
        4: '辅导-辅导1v1学员',
        5: '研讯-汇总专业数据',
      }
      return services[type] || ''
    },
    renderRecruitType(type) {
      const recruitTypes = {
        1: '第一志愿上岸',
        2: '调剂上岸',
        3: '推免',
      }
      return recruitTypes[type] || ''
    },
    renderGender(type) {
      const genders = {
        1: '学长',
        2: '学姐',
      }
      return genders[type] || ''
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.collegeCode = e
      this.senior.recruit_major_code = ''
      this.senior.recruit_major_name = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_direction_code = ''
      this.senior.recruit_direction_name = ''
      this.senior.recruit_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.$nextTick(() => {
        this.getMajor(e)
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    academyChange(e) {
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
        }
      })
    },
    directionChange(e) {
      this.senior.recruit_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    // 录取专业选择后还要搜索相对应的专业名称
    majorChange(e) {
      this.majorCode = e
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.recruit_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.collegeCode &&
        this.majorCode &&
        this.majorDirect(this.collegeCode, this.majorCode)
      this.$nextTick(() => {
        this.getSubjectsByMajorCode(this.senior.recruit_college_code, e)
      })
      this.$nextTick(() => {
        this.getAcademy(this.senior.recruit_college_code, e)
      })
    },
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    formateSenior() {
      let arr = []
      this.senior.test_subject_codes.forEach((item) => {
        arr.push(
          this.subjectsList.find((v) => {
            return v.subject_code === item //筛选出匹配数据
          }).subject_name
        )
      })
      this.senior.test_subject_codes = this.senior.test_subject_codes.join(',')
      this.senior.test_subject_names = arr.join(',')
    },
    handleSubmit() {
      if (!/^(\d+|\d+\.\d{1,2})$/.test(this.senior.fee_amount)) {
        this.$message.error('课时费输入最多两位小数的数字')
        return false
      }
      let intro_video_url = ''

      if (this.fileList && this.fileList.length) {
        intro_video_url = this.fileList.map((item) => item.url).join(',')
      }

      this.formateSenior()
      let query = {
        ...this.senior,
        intro_video_url: intro_video_url,
      }
      seniorUpdate(query)
        .then((res) => {
          this.$message.success(`学长学姐状态更新成功`)
          // 刷新数据
          this.$router.go(-1)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
  },
}
</script>

<style scoped lang="less">
.hide_box {
  ::v-deep.el-upload--picture-card {
    display: none;
  }
}
.setting {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }

    .content {
      // display: flex;
      margin-top: 20px;
    }
  }
  .baseinfo {
    .avatar {
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .userForm {
      width: 700px;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
  }
  .education {
    .education-wrap {
      display: flex;
    }
    .form-wrap {
      flex: 1;
    }
  }
  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
